import { FC, useState, useEffect } from "react";
import { Image } from "antd-mobile";
import "./index.scss";

const classPrefix = "yfm-danmaku";

interface DanmakuProps {
  danmakuText: string[];
  danmakuIcon: string;
  danmakuType: number;
}

const Danmaku: FC<DanmakuProps> = ({
  danmakuText,
  danmakuIcon,
  danmakuType,
}) => {
  const [isAnimate, setIsAnimate] = useState(false);

  useEffect(() => {
    setIsAnimate(true);
  }, []);

  return (
    <div className={`${classPrefix}__container`}>
      {isAnimate && (
        <div
          className={`${classPrefix}__content`}
          style={{ animation: `scroll${danmakuType} 10s linear infinite` }}
        >
          {danmakuText.map((item, index) => (
            <div className={`${classPrefix}__item`} key={index}>
              <Image
                className={`${classPrefix}__img`}
                width={0}
                height={0}
                src={danmakuIcon}
                alt=""
              />
              <div className={`${classPrefix}__text`}>{item}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Danmaku;
